import { render, staticRenderFns } from "./ArrowBox.vue?vue&type=template&id=b78ebe40&scoped=true"
import script from "./ArrowBox.vue?vue&type=script&lang=js"
export * from "./ArrowBox.vue?vue&type=script&lang=js"
import style0 from "./ArrowBox.vue?vue&type=style&index=0&id=b78ebe40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78ebe40",
  null
  
)

export default component.exports